import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

let instantUntil = 0;
export const markNavJump = () => {
  instantUntil = Date.now() + 1800;
};

export const fadeUp = {
  hidden: { opacity: 0, y: 36 },
  visible: (i = 0) => {
    const instant = Date.now() < instantUntil;
    return {
      opacity: 1,
      y: 0,
      transition: instant
        ? { duration: 0.25, ease: EASE, delay: 0 }
        : { duration: 0.9, ease: EASE, delay: i * 0.08 },
    };
  },
};

export const Reveal = ({ children, className = "", delay = 0, ...rest }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const instant = Date.now() < instantUntil;
  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y: 36 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 36 }}
      transition={
        instant
          ? { duration: 0.25, ease: EASE, delay: 0 }
          : { duration: 0.9, ease: EASE, delay: delay * 0.08 }
      }
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export const MaskedReveal = ({ lines, className = "", lineClassName = "", baseDelay = 0 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  return (
    <span ref={ref} className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "112%" }}
            animate={inView ? { y: "0%" } : { y: "112%" }}
            transition={
              Date.now() < instantUntil
                ? { duration: 0.35, ease: EASE, delay: 0 }
                : { duration: 1.05, ease: EASE, delay: baseDelay + i * 0.13 }
            }
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
